import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'p-announcement-management',
    templateUrl: './p-announcement-management.component.html',
    styleUrls: ['./p-announcement-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PAnnouncementManagementComponent {

}
